import apiFetch from '../apiFetch'

export default function (token, finderParams) {
  return apiFetch({
    endPoint: 'DossierFinder/ManagementDossierSelfSupply',
    method: 'POST',
    body: finderParams,
    token: token
  })
}
